export const MuiTableCell = {
	styleOverrides: {
		root: {
			padding: 10,
		},
	},
};
